<template>
  <VideoModal
    :isOpen="isVideoOpen"
    @closeModal="closeVideo"
    :title="$t('rc_promo_video_header')"
    itemKey="rateConnect"
    id="Rate Connect"
  />
  <div class="tw:md:my-[58px] tw:mt-10 tw:pt-5 tw:md:pt-0 tw:border-t tw:md:border-none" v-if="!hasRateConnect">
    <RateConnectEligible
      :hasRateConnect="hasRateConnect"
      :isRateConnectEligible="isRateConnectEligible"
      @openVideo="openVideo"
    />
  </div>
</template>
<script setup>
import { ref } from 'vue'

import RateConnectEligible from '@/components/homePage/rateConnect/RateConnectEligible.vue'
import VideoModal from '@/components/rateConnect/VideoModal.vue'

defineProps({
  isRateConnectEligible: Boolean,
  hasRateConnect: Boolean,
})

const isVideoOpen = ref(false)
const closeVideo = () => (isVideoOpen.value = false)
const openVideo = () => {
  isVideoOpen.value = true
}
</script>
